export const MENU_SURFACE_CLASS =
  "rounded-2xl border-border/60 bg-popover text-popover-foreground shadow-[0_4px_16px_rgba(0,0,0,0.06)] max-w-[calc(100vw-24px)]"

export const MENU_ROW_CLASS = "min-h-10 rounded-xl gap-3 px-3 py-2"
